import React from "react";
import { strings } from "../../../resources/strings";
import { AnswerIcon, BACK_PATH } from "./answerButtons";

const wf = strings.reportForm.workflow;

export interface ChangeAnswerButtonProps {
  /** Returns to the question's root (Yes/No or confirm) choice screen. */
  onClick: () => void;
}

/**
 * Secondary "Change my answer" control shown on a workflow's detailed
 * information step (StructuredForm form, ConfirmOnFileForm edit,
 * YesNoFreeTextForm details, RepeatableListForm list). Steps back to the
 * question's root choice so a participant can change their answer in place
 * rather than only via the Question List menu (EHA-903).
 *
 * Rendered only where a root choice exists to return to — ALWAYS structured
 * forms and DIRECT_LIST forms open straight on their detail step and so omit it.
 */
const ChangeAnswerButton: React.FC<ChangeAnswerButtonProps> = ({ onClick }) => (
  <button
    type="button"
    data-testid="change-answer"
    onClick={onClick}
    className="flex items-center justify-center gap-1 min-h-[44px] self-center px-3 font-semibold text-primary underline"
  >
    <AnswerIcon testId="change-answer-icon" path={BACK_PATH} />
    {wf.changeAnswer}
  </button>
);

export default ChangeAnswerButton;
